import React from 'react';

import TextValue from 'ui-library/TextValue';
import * as DateUtil from 'util/DateUtil';
import {Optional} from 'util/Types';

import TableCellWithTooltip, {NO_VALUE_TOOLTIP_TITLE} from './TableCellWithTooltip';

interface DatetimeTableCellProps {
  className?: string;
  datetime: Optional<string>;
  showTimeInCell: boolean;
}
export function DatetimeTableCell({
  className,
  datetime,
  showTimeInCell,
}: DatetimeTableCellProps): JSX.Element {
  return (
    <TableCellWithTooltip
      className={className}
      tooltipTitle={datetime ? DateUtil.readableTime(datetime, {showTime: true}) : NO_VALUE_TOOLTIP_TITLE}
    >
      <TextValue value={datetime && DateUtil.readableTime(datetime, {showTime: showTimeInCell})} />
    </TableCellWithTooltip>
  );
}
